import React, { useState } from 'react';

const CoinSelectorModal = ({
  cryptos,
  livePrices,
  selectedCoin,
  setSelectedCoin,
  setLimitPrice,
  setFormError,
  setFormSuccess,
  priceFlash,
  isOpen,
  onClose,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  if (!isOpen) return null;

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const filteredCryptos = cryptos.filter(coin => 
    coin.symbol.toLowerCase().includes(searchTerm.toLowerCase()) || 
    coin.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedCryptos = [...filteredCryptos].sort((a, b) => {
    if (!sortConfig.key) return 0;
    
    let aVal, bVal;
    
    if (sortConfig.key === 'coin') {
      aVal = a.symbol.toLowerCase();
      bVal = b.symbol.toLowerCase();
    } else if (sortConfig.key === 'price') {
      aVal = livePrices[a.symbol.toLowerCase()] || a.current_price;
      bVal = livePrices[b.symbol.toLowerCase()] || b.current_price;
    } else if (sortConfig.key === 'change') {
      aVal = a.price_change_percentage_24h || 0;
      bVal = b.price_change_percentage_24h || 0;
    }

    if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  return (
    <div className="coin-selector-modal-overlay" onClick={onClose}>
      <div className="coin-selector-modal-content" onClick={e => e.stopPropagation()}>
        <div className="coin-selector-modal-header">
          <h3>Symbol Search</h3>
          <button className="coin-selector-modal-close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border-color)' }}>
          <input
            type="text"
            placeholder="Search coin (e.g. BTC)"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
            style={{
              width: '100%',
              padding: '8px 12px',
              backgroundColor: 'var(--bg-primary)',
              border: '1px solid var(--border-color)',
              borderRadius: '4px',
              color: 'var(--text-primary)',
              outline: 'none'
            }}
          />
        </div>
        <aside className="coin-sidebar">
          <div className="coin-list-container">
        <table className="coin-list-table">
          <thead>
            <tr>
              <th onClick={() => handleSort('coin')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                Coin 
                <span style={{ opacity: sortConfig.key === 'coin' ? 1 : 0.4, marginLeft: '4px' }}>
                  {sortConfig.key === 'coin' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↕'}
                </span>
              </th>
              <th onClick={() => handleSort('price')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                Price
                <span style={{ opacity: sortConfig.key === 'price' ? 1 : 0.4, marginLeft: '4px' }}>
                  {sortConfig.key === 'price' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↕'}
                </span>
              </th>
              <th onClick={() => handleSort('change')} style={{ textAlign: 'right', cursor: 'pointer', userSelect: 'none' }}>
                24h %
                <span style={{ opacity: sortConfig.key === 'change' ? 1 : 0.4, marginLeft: '4px' }}>
                  {sortConfig.key === 'change' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↕'}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedCryptos.map((coin) => {
              const coinSym = coin.symbol.toLowerCase();
              const currentPrice = livePrices[coinSym] || coin.current_price;
              const isActive = selectedCoin && selectedCoin.id === coin.id;

              return (
                <tr 
                  key={coin.id} 
                  className={`coin-row ${isActive ? 'active-row' : ''}`}
                  onClick={() => {
                    setSelectedCoin(coin);
                    setLimitPrice((livePrices[coinSym] || coin.current_price || 0).toString());
                    setFormError('');
                    setFormSuccess('');
                    onClose();
                  }}
                >
                  <td>
                    <div className="coin-cell-name">
                      <span className="coin-symbol">{coin.symbol.toUpperCase()}</span>
                      <span className="coin-fullname">{coin.name}</span>
                    </div>
                  </td>
                  <td className={`price-cell ${priceFlash[coinSym] || ''}`}>
                    ${currentPrice?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 4 })}
                  </td>
                  <td className={`change-cell ${coin.price_change_percentage_24h >= 0 ? 'positive' : 'negative'}`} style={{ textAlign: 'right' }}>
                    {coin.price_change_percentage_24h >= 0 ? '+' : ''}{coin.price_change_percentage_24h?.toFixed(2)}%
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
        </aside>
      </div>
    </div>
  );
};

export default CoinSelectorModal;
